import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

// Multi-select autocomplete for variety synonyms, backed by VarietyFormSearchReflex.
// Hidden-input name is configurable via the paramName value.
export default class extends Controller {
  static targets = ["input", "results", "selectedIds", "selected", "spinner"];
  static values = {
    paramName: { type: String, default: "variety_form[synonym_variety_ids][]" },
  };

  connect() {
    StimulusReflex.register(this);
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    this.element.dataset.query = query;

    this.showSpinner();
    this.resultsTarget.classList.remove("hidden");
    this.resultsTarget.classList.add("opacity-50");

    this.stimulate("VarietyFormSearch#search");
  }

  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
    this.showSpinner();
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.hideSpinner();
  }

  searchError(error) {
    console.error("Variety search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
    this.hideSpinner();
  }

  select(event) {
    const varietyId = event.currentTarget.dataset.varietyId;
    const varietyName = event.currentTarget.dataset.varietyName;

    this.addSelectedVariety(varietyId, varietyName);
    this.inputTarget.value = "";
    this.resultsTarget.classList.add("hidden");
    this.selectedIdsTarget.dispatchEvent(new Event("change"));
  }

  removeVariety(event) {
    const varietyId = event.currentTarget.dataset.varietyId;

    event.currentTarget.closest("[data-variety-item]").remove();

    const hiddenInput = this.selectedIdsTarget.querySelector(
      `input[value="${varietyId}"]`
    );
    if (hiddenInput) {
      hiddenInput.remove();
    }

    this.selectedIdsTarget.dispatchEvent(new Event("change"));
  }

  addSelectedVariety(varietyId, varietyName) {
    if (this.selectedIdsTarget.querySelector(`input[value="${varietyId}"]`)) {
      return;
    }

    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = this.paramNameValue;
    hiddenInput.value = varietyId;
    this.selectedIdsTarget.appendChild(hiddenInput);

    const selectedItem = document.createElement("div");
    selectedItem.className =
      "flex items-center justify-between bg-indigo-50 border border-indigo-200 rounded-lg px-3 py-2";
    selectedItem.setAttribute("data-variety-item", varietyId);

    selectedItem.innerHTML = `
      <span class="text-sm font-medium text-indigo-900">${varietyName}</span>
      <button type="button"
              class="text-indigo-600 hover:text-indigo-800 ml-2 transition-colors duration-200"
              data-action="click->variety-form-search#removeVariety"
              data-variety-id="${varietyId}">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    `;

    this.selectedTarget.appendChild(selectedItem);
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }

  receiveResults(html) {
    this.resultsTarget.innerHTML = html;
    this.resultsTarget.classList.remove("hidden");
  }
}
